export const HOST: string = process.env.VUE_APP_DEVHOST
  ? process.env.VUE_APP_DEVHOST
  : process.env.NODE_ENV === "development"
  ? "http://localhost:8080"
  : "";
export const API_URL: string = `${HOST}/api/v2`;
//export const GMAP_KEY: string = 'AIzaSyAXBLVacmhaAGj4mnRj8A2B2Az1X8DgM3A';
//export const GMAP_KEY: string = 'AIzaSyBMsTZnGiQchkPm1LbG39fwpdO9Jh0vZ34';
//export const GMAP_KEY: string = "AIzaSyDcEkMFV_WyhNdZrr8VLaCYOw4FP75u748";
// const API_KEY = 'AIzaSyCWAaBJsI1234TI18PITVy7p0Qb6ht123';
